<template>
  <div class="footer heis">
    <div class="w-75 d-center-between m-auto pl-5 pr-5 pt-4 pb-4 ">
      <div class="w-75 d-start-center flex-column m-auto web-link">
        <div class="h6 pb-4">
          <router-link to="/about_us">关于我们</router-link>
          <router-link to="/about_us/team_detail">团队介绍</router-link>
          <router-link to="/about_us/join_us">诚征英才</router-link>
          <router-link to="/about_us/contact_us">联系我们</router-link>
          <span class="ml-auto">服务热线：0571-89986918</span>
        </div>
        <div class="d-flex align-items-center">
          <span class="h6 pr-1">Copyright © 2017-{{new Date().getFullYear()}} / <a target="_blank" class="mr-0" href="https://beian.miit.gov.cn">ICP备案：浙ICP备2020041054号-{{_IsDevMode?2:7}}</a></span>
           
            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010202005224" class="d-flex align-items-center" v-if="!_IsDevMode">
              <img src="/images/public/beian.png" alt="" height="15">浙公网安备 33010202005224号
            </a>
        </div>
        <div class="d-flex align-items-center mt-3">
          <p class="text-red" v-if="_IsDevMode">本网站为订单雨内部测试使用，不对外开放。主体信息与dingdanyu.com一致。</p>
        </div>
      </div>
      <!-- <img class="ml-auto" src="/images/login/qr_code.jpg" height="100" width="100"/> -->
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NavFooter',
  }
</script>

<style lang="scss" scoped>
  .footer {
    background: #3d3d3d;
    min-width: 1200px;
    width: 100%;
  }

  .web-link {
    padding: 15px 0 0 0;
    font-size: 14px;
    a {
      margin-right: 30px;
      color: #fff;
      // &:hover {
      //   color: #12b2cb;
      // }
    }
  }
  .heis{
    background-color: #363e50;
  }
  .heis {
    color: #fff;
  }
</style>
